var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GEMINI_SUMMARY_I18N, GEMINI_SUMMARY_PENDING_VALUE, GeminiSummaryMetricLine } from '@web/components/Apps/Gemini/geminiSummaryCards';
import LegendItem from '@web/components/layout/RechartsItems/LegendItem';
import { GEMINI_USAGE_LEVEL_COLORS_CONFIG, TablesDiffColorsConfig } from '@web/config';
import { cx } from '@web/utility';
import { GEMINI_USAGE_LEVELS } from '@workalizer/shared/lib/gemini-usage-level';
export function ClickableGeminiUsageLevelLegend(_a) {
    var t = _a.t, toggleSeries = _a.toggleSeries, isSeriesVisible = _a.isSeriesVisible, items = _a.items, onValueClick = _a.onValueClick;
    var legendItems = items !== null && items !== void 0 ? items : GEMINI_USAGE_LEVELS.map(function (level) { return ({ level: level }); });
    return (_jsx("div", __assign({ className: "mb-6 ml-2 flex flex-wrap justify-start gap-8 rounded-lg p-4 lg:gap-8" }, { children: _jsx("div", __assign({ className: "flex flex-col flex-wrap justify-start gap-2 lg:flex-row lg:gap-4" }, { children: legendItems.map(function (_a) {
                var level = _a.level, currentValue = _a.currentValue, diffValue = _a.diffValue, teamAverage = _a.teamAverage;
                return (_jsx(LegendItem, { color: GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].color, label: formatGeminiUsageLevelLabel(level, true, t), currentValue: currentValue, diffValue: diffValue, teamAverage: teamAverage, stripeChartColor: teamAverage
                        ? GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].teamChartColor
                        : undefined, arrowColor: TablesDiffColorsConfig.GREEN, onClick: function () { return toggleSeries(level); }, onValueClick: onValueClick, isHidden: !isSeriesVisible(level) }, level));
            }) })) })));
}
export var formatGeminiUsageLevelLabel = function (level, isPeriodValid, t) {
    if (!isPeriodValid || level === null) {
        return GEMINI_SUMMARY_PENDING_VALUE;
    }
    var translationKey = GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].translationKey;
    return t("".concat(GEMINI_SUMMARY_I18N, ".usageLevels.").concat(translationKey));
};
var getGeminiUsageLevelSwatchClassName = function (level, isPeriodValid) {
    return isPeriodValid && level !== null
        ? GEMINI_USAGE_LEVEL_COLORS_CONFIG[level].color
        : undefined;
};
export var GeminiSummaryUsageLevelMetric = function (_a) {
    var level = _a.level, isPeriodValid = _a.isPeriodValid, prevPeriodDiff = _a.prevPeriodDiff, t = _a.t, _b = _a.comparisonLayout, comparisonLayout = _b === void 0 ? 'inline' : _b;
    var swatchClassName = getGeminiUsageLevelSwatchClassName(level, isPeriodValid);
    return (_jsxs("div", __assign({ className: "mt-1.5 flex min-w-0 max-w-full flex-wrap items-center gap-1.5" }, { children: [swatchClassName ? (_jsx("span", { className: cx('h-2.5 w-2.5 shrink-0 rounded-sm', swatchClassName), "aria-hidden": true })) : null, _jsx(GeminiSummaryMetricLine, { value: formatGeminiUsageLevelLabel(level, isPeriodValid, t), prevPeriodDiff: prevPeriodDiff, layout: comparisonLayout })] })));
};
